<template>

    <div>
        <!--分隔线-->
        <div v-if="type=='红色双线'">
            <div style="width: 170mm;margin-left:-8mm;border-bottom: 1mm red solid;"></div>
            <div style="margin-top:0.2mm;width: 170mm;margin-left:-8mm;border-bottom: 0.2mm red solid;"></div>
        </div>

        <!--分隔线-->
        <div style="margin-top: 3px;" v-if="type=='上细下粗'">
            <div style="width: 170mm;margin-left:20mm;border-bottom: 0.2mm red solid;"></div>
            <div style="margin-top:0.5mm;width: 170mm;margin-left:20mm;border-bottom: 1mm red solid;"></div>
        </div>

        <!--分隔线-->
        <div v-if="type=='红色单线'">
            <div style="width: 156mm;border-bottom: 1mm red solid;"></div>
        </div>

        <!--分隔线-->
        <div v-if="type=='五角星'">
            <div style="width: 74.8mm;border-bottom: 2pt red solid; float: left; margin-top: 8px; margin-right: 1mm"></div>
            <div style="float: left;color: red;font-size: 12pt;">★</div>
            <div style="width: 74.8mm;border-bottom: 2pt red solid; float: left; margin-top: 8px; margin-left: 1mm"></div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Divider",
        props: {
            type: {}
        }
    }
</script>
